import React, { useLayoutEffect } from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

const DashboardChart = ({ data }) => {
  useLayoutEffect(() => {
    let root = am5.Root.new("chartdiv");

    root.setThemes([am5themes_Animated.new(root)]);

    // Create chart
    let chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        panX: false,
        panY: false,
        wheelX: "panX",
        wheelY: "zoomX",
        layout: root.verticalLayout,
      })
    );

    // Create X axis
    let xAxis = chart.xAxes.push(
      am5xy.CategoryAxis.new(root, {
        categoryField: "month",
        renderer: am5xy.AxisRendererX.new(root, { minGridDistance: 30 }),
      })
    );

    xAxis.data.setAll(data);

    let yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        min: 0,
        extraMax: 0.1,
        renderer: am5xy.AxisRendererY.new(root, {}),
      })
    );

    let singleSeries = chart.series.push(
      am5xy.ColumnSeries.new(root, {
        name: "Total",
        xAxis: xAxis,
        yAxis: yAxis,
        valueYField: "totalValue",
        categoryXField: "month",
        fill: am5.color("#007BFF"),
      })
    );

    singleSeries.columns.template.setAll({
      width: am5.percent(90),
      tooltipText: "{name}: {valueY}",
      cornerRadiusTopLeft: 12,
      cornerRadiusTopRight: 12,
    });

    singleSeries.data.setAll(data);

    // Animate on load
    chart.appear(1000, 100);

    return () => root.dispose();
  }, []);

  return <div id="chartdiv" style={{ width: "100%", height: "100%" }}></div>;
};

export default DashboardChart;
